(() => {
  const fmt = (c) => '$' + (c / 100).toFixed(2);

  // Home page: all "#shop" buttons go to the product page
  if (location.pathname === '/' || location.pathname === '') {
    document.querySelectorAll('a[href="#shop"]').forEach((a) => {
      if (!a.closest('.vl-sticky')) a.setAttribute('href', '/products/tenora-neck-firming-cream');
    });
  }

  document.querySelectorAll('[data-vl-buy]').forEach((box) => {
    const pt = box.querySelector('[data-vl-ptype]');
    if (!pt) return;
    const pct = +pt.dataset.subPct || 10;
    const chk = box.querySelector('[data-vl-subchk]');
    const plan = box.querySelector('[data-vl-plan]');
    const upd = () => {
      const sub = chk.checked;
      box.querySelectorAll('input[name=vl-tier]').forEach((r) => {
        const c = +r.dataset.cents, cmp = +r.dataset.cmp || 0, n = +r.dataset.n || 1;
        const shown = sub ? Math.round(c * (100 - pct) / 100) : c;
        const was = sub ? (cmp || c) : cmp;
        const lab = r.closest('.vl-tier');
        lab.querySelector('[data-tp]').textContent = fmt(shown);
        lab.querySelector('[data-tw]').textContent = was > shown ? fmt(was) : '';
        lab.querySelector('[data-tper]').textContent = fmt(Math.round(shown / n));
        if (r.checked) document.querySelectorAll('[data-vl-price]').forEach((e) => (e.textContent = fmt(shown)));
      });
      if (plan) plan.disabled = !sub;
    };
    box.addEventListener('change', (e) => {
      if (e.target.matches('input[name=vl-tier], [data-vl-subchk]')) setTimeout(upd, 0);
    });
    // Subscribe & Save is pre-selected on every page load (also after back/forward cache)
    chk.checked = true;
    upd();
    window.addEventListener('pageshow', () => { chk.checked = true; upd(); });
  });

  // UpCart drawer: +/- steps by one jar and swaps to the matching bundle variant (1/2/3 Jars),
  // so the price follows the bundle pricing. Bundles above 3 jars split into 3-jar bundles + rest.
  const HANDLE = 'tenora-neck-firming-cream';
  const ofetch = window.fetch.bind(window);
  const J = (o) => ({ method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(o) });
  let variantsByJars = null;
  const loadVariants = async () => {
    if (variantsByJars) return variantsByJars;
    const p = await ofetch('/products/' + HANDLE + '.js').then((r) => r.json());
    variantsByJars = {};
    p.variants.forEach((v) => { const n = parseInt(v.title, 10) || 1; variantsByJars[n] = v.id; });
    return variantsByJars;
  };
  window.fetch = async function (input, init) {
    try {
      const url = String((input && input.url) || input || '');
      if (/\/cart\/change(\.js)?/.test(url) && init && typeof init.body === 'string' && init.body[0] === '{') {
        const body = JSON.parse(init.body);
        const q = +body.quantity;
        if (q > 0 && (body.id || body.line)) {
          const cart = await ofetch('/cart.js').then((r) => r.json());
          const item = body.line ? cart.items[body.line - 1] : cart.items.find((i) => i.key === body.id || String(i.id) === String(body.id) || String(i.variant_id) === String(body.id));
          if (item && item.handle === HANDLE && q !== item.quantity) {
            const vmap = await loadVariants();
            const per = parseInt(item.variant_title, 10) || 1;
            let jars = per * item.quantity + (q - item.quantity);
            if (jars < 1) jars = 1;
            const plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.id;
            const max = Math.max(...Object.keys(vmap).map(Number));
            const items = [];
            while (jars > 0) {
              const n = Math.min(jars, max);
              const it = { id: vmap[n], quantity: 1 };
              if (plan) it.selling_plan = plan;
              const same = items.find((x) => x.id === it.id);
              same ? same.quantity++ : items.push(it);
              jars -= n;
            }
            await ofetch('/cart/change.js', J({ id: item.key, quantity: 0 }));
            await ofetch('/cart/add.js', J({ items }));
            return ofetch('/cart.js');
          }
        }
      }
    } catch (e) { /* fall through to the normal request */ }
    return ofetch(input, init);
  };
  // UpCart: quantity field shows JARS (2-Jar bundle = 2), +/- adds/removes one jar and
  // re-packs all Tenora lines into the cheapest bundles (3 + rest).
  const getRoot = () => window.upcartDocumentOrShadowRoot || null;
  const tiles = () => { const r = getRoot(); return r ? [...r.querySelectorAll('.upcart-internal-cart-item')] : []; };
  const jarsOf = (i) => (parseInt(i.variant_title, 10) || 1) * i.quantity;
  let busy = false;
  const paint = async () => {
    const t = tiles(); if (!t.length) return;
    const cart = await ofetch('/cart.js').then((r) => r.json());
    t.forEach((tile, idx) => {
      const it = cart.items[idx]; const inp = tile.querySelector('.upcart-internal-component-product-tile__quantity-selector input');
      if (!it || !inp) return;
      inp.readOnly = true;
      const v = String(it.handle === HANDLE ? jarsOf(it) : it.quantity);
      if (inp.value !== v) inp.value = v;
    });
  };
  let pt = null; const schedule = () => { clearTimeout(pt); pt = setTimeout(paint, 120); };
  const watch = () => { const r = getRoot(); if (!r) return setTimeout(watch, 500); new MutationObserver(() => { if (!busy) schedule(); }).observe(r, { childList: true, subtree: true, characterData: true }); schedule(); };
  watch();
  document.addEventListener('click', async (e) => {
    const btn = e.composedPath().find((n) => n.classList && (n.classList.contains('upcart-internal-component-product-tile__quantity-plus') || n.classList.contains('upcart-internal-component-product-tile__quantity-minus')));
    if (!btn) return;
    const tile = btn.closest('.upcart-internal-cart-item'); const idx = tiles().indexOf(tile);
    if (idx < 0) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    if (busy) return; busy = true;
    try {
      const cart = await ofetch('/cart.js').then((r) => r.json());
      const item = cart.items[idx];
      if (!item) return;
      const step = btn.classList.contains('upcart-internal-component-product-tile__quantity-plus') ? 1 : -1;
      if (item.handle !== HANDLE) {
        await ofetch('/cart/change.js', J({ id: item.key, quantity: Math.max(0, item.quantity + step) }));
      } else {
        const vmap = await loadVariants();
        const plan = item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.id : null;
        const same = cart.items.filter((i) => i.handle === HANDLE && ((i.selling_plan_allocation ? i.selling_plan_allocation.selling_plan.id : null) === plan));
        let jars = same.reduce((a, i) => a + jarsOf(i), 0) + step;
        const max = Math.max(...Object.keys(vmap).map(Number));
        const items = [];
        while (jars > 0) {
          const n = Math.min(jars, max); const it = { id: vmap[n], quantity: 1 };
          if (plan) it.selling_plan = plan;
          const ex = items.find((x) => x.id === it.id); ex ? ex.quantity++ : items.push(it);
          jars -= n;
        }
        const upd = {}; same.forEach((i) => { upd[i.key] = 0; });
        await ofetch('/cart/update.js', J({ updates: upd }));
        if (items.length) await ofetch('/cart/add.js', J({ items }));
      }
    } catch (err) { /* ignore */ }
    finally { busy = false; if (window.upcartRefreshCart) window.upcartRefreshCart(); schedule(); setTimeout(paint, 900); }
  }, true);
})();
